import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { canManageOrg } from "../lib/permissions";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminSubNav = ({ user, activeTab }) => {
  const navigate = useNavigate();
  const [recycleBinCount, setRecycleBinCount] = useState(0);

  const canSeePurchases = canManageOrg(user);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const resp = await axios.get(`${API}/admin/recycle-bin/items/count`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRecycleBinCount(resp.data?.count || 0);
      } catch (e) {
        // silently ignore
      }
    };
    fetchCount();
  }, []);

  const tabs = [
    { key: "home", label: "Home", path: "/" },
    { key: "overview", label: "Overview", path: "/admin" },
    { key: "items", label: "Items", path: "/admin/items" },
    { key: "collections", label: "Collections", path: "/collections" },
    {
      key: "recycle-bin",
      label: "Recycle Bin",
      path: "/admin/recycle-bin",
      badge: recycleBinCount > 0 ? recycleBinCount : null,
    },
    { key: "users", label: "Users", path: "/admin/users" },
    { key: "submissions", label: "Submissions", path: "/admin/submissions" },
    { key: "logs", label: "Logs", path: "/admin/logs" },
    { key: "imports", label: "Imports", path: "/admin/imports" },
    { key: "topics", label: "Topics", path: "/admin/topics" },
    { key: "research", label: "AI Researcher", path: "/admin/research-analytics" },
    { key: "organizations", label: "Organizations Summary", path: "/admin/organizations" },
    ...(canSeePurchases ? [{ key: "purchases", label: "Purchases", path: "/admin/purchases" }] : []),
    { key: "subscriptions", label: "Subscriptions", path: "/admin/subscriptions" },
    { key: "announcements", label: "Announcements", path: "/admin/announcements" },
    { key: "audit", label: "Audit", path: "/admin/audit" },
    { key: "settings", label: "Settings", path: "/admin/settings" },
  ];

  return (
    <div className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => navigate(tab.path)}
              className={`py-4 border-b-2 font-medium whitespace-nowrap flex items-center gap-1.5 ${
                activeTab === tab.key
                  ? "border-orange-500 text-slate-900"
                  : "border-transparent text-slate-600 hover:text-slate-900"
              }`}
              data-testid={`admin-nav-${tab.key}`}
            >
              {tab.label}
              {tab.badge != null && (
                <span
                  className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-[10px] font-bold rounded-full bg-red-500 text-white"
                  data-testid="recycle-bin-badge"
                >
                  {tab.badge > 99 ? "99+" : tab.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminSubNav;
